import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './LegalDocument.css';

export default function LegalLayout({ title, lastUpdated, children }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const previousTitle = document.title;
    document.title = `${title} | Longfloat AI`;

    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.title = previousTitle;
    };
  }, [title]);

  return (
    <div className="legal-page min-h-screen bg-white">
      <Header scrolled={scrolled} isSubpage alwaysBorder />
      <main className="pt-28 sm:pt-32">
        <article className="legal-doc mx-auto max-w-[760px] px-6 py-12 sm:py-16 lg:py-20">
          <header>
            <h1>{title}</h1>
            {lastUpdated ? (
              <p className="legal-updated">Last updated: {lastUpdated}</p>
            ) : null}
          </header>
          <div className="legal-body">{children}</div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
